const warned = new Set()
export async function warnOnce(key, ...args) {
  if (!warned.has(key)) {
    console.warn(...args)
  }
  warned.add(key)
}
